<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <card>
                    <div class="content search">
                        <form @submit.stop.prevent="searchByValue">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <div class="col-md-12">
                                            <label>Buscar</label>
                                        </div>
                                        <div class="col-md-12">
                                            <input type="text" name="search" v-model.trim="searchValue"
                                                class="form-control border-input" placeholder="Nome / Autor" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </card>
                <card>
                    <router-link to="add-user" class='btn btn-info'>Novo Usuário</router-link>
                </card>
                <div class="row">
                    <div class="col col-md-6 col-12" v-for="user in obras" :key="`user-${user.id}`">

                        <card>
                            <div class='row'>
                                <div class='col-md-9 col-12'>
                                    <strong>Nome: {{ user.name }}</strong>
                                </div>
                                <div class='col-md-9 col-12'>
                                    <strong>Email: {{ user.email }}</strong>
                                </div>
                                <div class='col-md-9 col-12'>
                                    <strong>Role:
                                        <span class="badge"
                                            :class="{ 'badge-info': user.role === 'editor', 'badge-danger': user.role === 'desativado', 'badge-warning': user.role === 'admin', 'badge-success': user.role === 'superuser' }">{{
                                                user.role }}</span></strong>
                                </div>
                                <div class='col-md-3 col-12'>
                                    <div>
                                        <router-link class='btn btn-warning btn-block'
                                            :to="{ name: 'Editar Usuário', params: { id: user.id } }">Editar</router-link>


                                        <button class='btn btn-danger btn-block' @click="trocarSenha(user.id)">Trocar
                                            Senha</button>
                                    </div>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
                <pagination :count="count" :limit="limit" :page="page" @changePage="changePage($event)"></pagination>
            </div>
        </div>
    </div>
</template>
<script>
import UsersService from '../services/users-service'
import { TableObras } from '@/components'
import { Pagination } from '@/components'
import ObraFilter from './Busca/ObraFilter'
import OverlayService from '../services/overlay-service'
import AuthService from '../services/auth-service'

import { mapGetters } from 'vuex'

export default {
    components: {
        TableObras,
        Pagination,
        ObraFilter
    },

    data() {
        return {
            obras: [],
            offset: 0,
            searchValue: '',
            limit: 10,
            count: 0,
            page: 0,
            selectedCategoria: null,
            selectedColecao: null,
            selectedTag: null
        }
    },
    computed: {
        ...mapGetters(['isLogged', 'isAdmin', 'isPresbiterio'])
    },
    mounted() {
        this.searchObras()
    },
    methods: {

        trocarSenha(id, name) {
            this.$alertify.promptWithTitle(
                'Trocar Senha de ' + name,
                'Digite a nova senha',
                '',
                (ev, password) => {
                    OverlayService.trigger('show', true)
                    AuthService.changePasswordById(id,{ password })
                        .then(() => {
                            this.$alertify.success('Senha alterada com sucesso!')
                        })
                        .catch((er) => this.$alertify.error('Erro ao trocar senh'))
                        .finally(() => {
                            OverlayService.trigger('show', false)
                        })
                },
                () => { }
            )
        },

        searchObras() {
            const order = [{ orderBy: 'id', direction: 'asc' }]

            const filter = {
                limit: this.limit,
                page: this.page + 1,
                orderBy: order,
                search: this.searchValue
            }

            OverlayService.trigger('show', true)

            UsersService.getAll(filter)
                .then(response => response.data)
                .then(data => {
                    OverlayService.trigger('show', false)
                    this.obras = data.data
                    this.count = data.total
                })
                .catch(er => OverlayService.trigger('show', false))
        },

        searchByValue() {
            this.page = 0
            this.searchObras()
        },

        changePage(page) {
            this.page = page
            this.searchObras()
        },

        submitBuscaCategoria(categoria) {
            this.selectedCategoria = categoria
            this.page = 0
            return this.searchObras()
        },

        submitBuscaColecao(colecao) {
            this.selectedColecao = colecao
            this.page = 0
            return this.searchObras()
        },

        submitBuscaTag(tag) {
            this.selectedTag = tag
            this.page = 0
            return this.searchObras()
        },

        downloadCsv() {
            OverlayService.trigger('show', true)

            ObraService.getCsv()
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'acervo.csv')
                    document.body.appendChild(link)
                    link.click()
                })
                .finally(() => {
                    OverlayService.trigger('show', false)
                })
        }
    }
}
</script>
<style scoped>
.content.search {
    position: relative;
}

.download-csv {
    position: absolute;
    right: 0;
    top: 0;
}
</style>
